// storage.ts
import localForage from 'localforage';

localForage.config({
  name: 'ifood-app',
  storeName: 'persist', // название хранилища
  description: 'redux-persist store',
}); // driver сам подберётся: IndexedDB → WebSQL → localStorage

export const idbStorage = {
  getItem: (key: string) => localForage.getItem<string>(key),
  setItem: (key: string, value: string) => localForage.setItem(key, value),
  removeItem: (key: string) => localForage.removeItem(key),
};
